import { Component, OnInit, Input } from '@angular/core';
import { generateTitleDiv, undefinedImagePath } from 'src/modules/empower-module/helper';
import { EmpowerGamingService } from 'src/services/empower-services/empower-gaming.service';
import { EmpowerExportService } from 'src/services/empower-services/empower-export.service';


@Component({
  selector: 'empower-xbox-series-s',
  templateUrl: './empower-xbox-series-s.component.html',
  styleUrls: ['./empower-xbox-series-s.component.scss']
})
export class EmpowerXboxSeriesSComponent implements OnInit {

  @Input() data?: any;
  imageUrl = "../assets/empower/xbox-pitch-factory/images/16-screen-02.jfif";

  innerHtml = '';
  constructor(public empowerGamingService: EmpowerGamingService, private empowerExportService: EmpowerExportService,) { }

  ngOnInit(): void {
    if (this.data) {
      this.data = JSON.parse(this.data);

      this.checkPageState(this.data.pageId);
    }
  }

  checkPageState(pageId) {
    const imageUrl = this.empowerGamingService.getPageImgState(pageId);
    if (imageUrl) {
      this.imageUrl = imageUrl;
    }
    this.innerHtml = generateTitleDiv(this.data);
  }

  imageChange(imageUrl) {
    this.empowerGamingService.setPageImgState(this.data.pageId, imageUrl);
  }

  emitExportEvent(resolvedState: boolean) {
    setTimeout(() => {
      this.data && this.data.export && this.empowerExportService.setExportComponentSubject(16, resolvedState, this.data.pageIndex, this.data.pageTitle);
    }, 1000);
  }


}
